var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BLACK_800, BLACK_900, Divider, DynamicSvg, LILAC_400, Typography, WHITE, tokens } from '@airtel/air-design-system';
import { FlatList, View } from 'react-native';
import { getChoronologicalListWidgetStyles, getContentListItemSpacingHorizontal } from './ChoronologicalListWidgetStyles';
export var ChoronologicalListWidgetComponent = props => {
  var _props$headerList = props.headerList,
    headerList = _props$headerList === void 0 ? [] : _props$headerList,
    _props$contentList = props.contentList,
    contentList = _props$contentList === void 0 ? [] : _props$contentList,
    _props$numberOfColumn = props.numberOfColumn,
    numberOfColumn = _props$numberOfColumn === void 0 ? 3 : _props$numberOfColumn,
    style = props.style,
    restProps = __rest(props, ["headerList", "contentList", "numberOfColumn", "style"]);
  var choronologicalListWidgetStyles = getChoronologicalListWidgetStyles();
  var HeaderListItem = () => {
    return _jsxs(_Fragment, {
      children: [_jsx(View, Object.assign({
        style: choronologicalListWidgetStyles.headerListItemContainer
      }, {
        children: headerList === null || headerList === void 0 ? void 0 : headerList.map((item, index) => {
          if (index >= numberOfColumn) return null;
          var iconName = item.iconName,
            title = item.title,
            _item$titleColor = item.titleColor,
            titleColor = _item$titleColor === void 0 ? BLACK_900 : _item$titleColor,
            iconProps = item.iconProps;
          return _jsxs(View, Object.assign({
            style: [choronologicalListWidgetStyles.headerListItem]
          }, {
            children: [!!iconName && _jsx(DynamicSvg, Object.assign({
              iconName: iconName,
              fontSize: 16
            }, iconProps)), _jsx(Typography, {
              text: title,
              color: titleColor,
              type: "body-single-line-sm-bold",
              style: {
                marginLeft: tokens.spacing.SPACING_4
              }
            })]
          }), "heading_list_item_" + index);
        })
      })), _jsx(Divider, {
        height: 2,
        color: LILAC_400,
        shadowColor: WHITE,
        style: choronologicalListWidgetStyles.dividerSpacing
      })]
    });
  };
  var contentListItem = _ref => {
    var item = _ref.item,
      index = _ref.index;
    if (!item) return _jsx(View, {
      style: [choronologicalListWidgetStyles.contentListItemContainer]
    });
    var _item$title = item.title,
      title = _item$title === void 0 ? '' : _item$title,
      _item$content = item.content,
      content = _item$content === void 0 ? [] : _item$content,
      _item$showComma = item.showComma,
      showComma = _item$showComma === void 0 ? true : _item$showComma;
    return _jsx(_Fragment, {
      children: _jsxs(View, Object.assign({
        style: [choronologicalListWidgetStyles.contentListItemContainer, getContentListItemSpacingHorizontal(index, numberOfColumn)]
      }, {
        children: [!!title && _jsx(View, Object.assign({
          style: choronologicalListWidgetStyles.contentListItemTitleContainer
        }, {
          children: _jsx(Typography, {
            text: title,
            color: BLACK_800,
            type: "title-single-line-md",
            style: {
              marginLeft: tokens.spacing.SPACING_8
            }
          })
        })), !!(content === null || content === void 0 ? void 0 : content.length) && _jsx(View, {
          children: content === null || content === void 0 ? void 0 : content.map((name, index) => _jsx(Typography, {
            text: index !== (content === null || content === void 0 ? void 0 : content.length) - 1 ? "" + name + ("" + (showComma ? ',' : '')) : name,
            type: "body-para-xs",
            color: BLACK_800
          }, "content_item_" + index))
        })]
      }))
    });
  };
  var numsColumn = numberOfColumn || 1;
  var emptySpaceReq = numsColumn - ((contentList === null || contentList === void 0 ? void 0 : contentList.length) || 0) % numsColumn;
  return _createElement(FlatList, Object.assign({
    data: [...contentList, ...Array(emptySpaceReq === 3 ? 0 : emptySpaceReq).fill('')],
    keyboardShouldPersistTaps: "handled",
    renderItem: contentListItem,
    numColumns: numberOfColumn,
    ListHeaderComponent: !!(headerList === null || headerList === void 0 ? void 0 : headerList.length) && _jsx(HeaderListItem, {}),
    style: [choronologicalListWidgetStyles.container, style]
  }, restProps, {
    key: numsColumn
  }));
};
ChoronologicalListWidgetComponent.genericRendererKey = 'AirChoronologicalListWidget';